// extracted by mini-css-extract-plugin
module.exports = {"page":"Page_page__nh2Fz","fullHeightHero":"Page_fullHeightHero__FMytw"};